import styled from 'vue3-styled-components'

const SFSMatrixSelectAndSelectBox = styled.section`
  .select-box-card {
    margin-bottom: 1em;
  }
`

export default SFSMatrixSelectAndSelectBox
